import { makeAutoObservable } from "mobx";
import { RDate } from "../../core";
import { InternalParameterSet, ParameterSet, ScheduleParameterSet, } from "../ParameterSet";
export class PurchaseOrderScope {
    constructor(params) {
        this.restaurant = params.restaurant;
        this.inCartPromotionTypes = params.inCartPromotionTypes;
        this.salesChannel = params.salesChannel;
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        this.now = RDate.now(params.restaurant.timezone);
        makeAutoObservable(this);
    }
    get parameterSet() {
        const schedules = this.restaurant.menu.schedules.union(this.inCartPromotionTypes.schedules);
        return new ParameterSet({
            schedule: this.preorderTime === null
                ? ScheduleParameterSet.empty()
                : ScheduleParameterSet.matchingFulfillmentTime(schedules, this.preorderTime),
            internal: new InternalParameterSet({
                orderOrigin: this.salesChannel.menuOrderOrigin,
                fulfillmentMethod: this.fulfillmentInstructions.fulfillmentMethod,
                splitToHalves: null,
            }),
        });
    }
    get currentFulfillmentTimes() {
        // TODO Update time automatically maybe?
        return this.restaurant.currentFulfillmentTimes(this.now);
    }
    get preorderTime() {
        const preorderTime = this.fulfillmentInstructions.fulfillmentTime;
        if (preorderTime === null) {
            return null;
        }
        const date = preorderTime.type === "ASAP" ? this.now : preorderTime.date;
        return date;
    }
}
